import RoleManagement from '@/views/permission/RoleManagement.vue';
import { SafetyCertificateOutlined } from '@ant-design/icons-vue';

export const permissionRoutes = [
    {
        path: 'role-management',
        component: RoleManagement,
        name: 'RoleManagement',
        meta: {
            title: '角色列表',
            icon: SafetyCertificateOutlined
        }
    }
];
